export class OneListUpdate {
  id: number;
  projectId: number;
  enteredAt: Date;
  enteredBy: string;
  updateContent: string;
}
